import { LandTitleDto } from "@cradua/data";
import { environment } from "apps/epims/mrsoftepims/src/environments/environment";
import { HttpClient, HttpParams, HttpHeaders, HttpEvent, HttpRequest } from "@angular/common/http";

import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AcquisitionService {
  url = `${environment.apiUrl}acquisition-management`;
  constructor(private http: HttpClient) {}

  getAcquisition(): Observable<LandTitleDto[]> {
    return this.http.get<LandTitleDto[]>(this.url);
  }

  createAcquisition(data: LandTitleDto): Observable<LandTitleDto> {
    return this.http.post<LandTitleDto>(this.url, data);
  }
  getSingleAcquisition(id: string): Observable<any> {
    return this.http.get(this.url + "/" + id);
  }

  fetchAcquisition(query: any): Observable<LandTitleDto[]> {
    return this.http.post<LandTitleDto[]>(this.url + "/fetch", query);
  }

  fetchByIdAcquisition(id: any): Observable<LandTitleDto[]> {
    return this.http.post<LandTitleDto[]>(this.url + "/fetchById", {id});
  }

  updateAcquisition(data: LandTitleDto): Observable<LandTitleDto> {
    return this.http.post<LandTitleDto>(this.url + "/update", data);
  }

  deleteAcquisition(id: string) {
    return this.http.post(this.url + "/" + id, {});
  }

  getReportRef() {
    return this.http.get(`${environment.apiUrl}report-reference`);
  }

  public uploadFile(
    file: File,
    data: any,
  ) {
    const formData = new FormData();
    if( typeof file !== 'string' && file) {
      // console.log("Reaching Service for Upload doc", file);
      formData.append("Document", file, file.name);
    }
    formData.append("Body", JSON.stringify(data));

    const selectedUrl = 'report-reference/document-upload';


    const options = {
      reportProgress: true,
    };

    const req = new HttpRequest(
      "POST",
      `${environment.apiUrl + selectedUrl}`,
      formData,
      options,
    );

    // console.log("Http Request ", req);
    return this.http.post(`${environment.apiUrl + selectedUrl}`, formData);
  }
}
